/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const TenantAPI = {
  getTenant: async () =>
    (await initAxios())
      ?.get('/tenant/')
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getTenantAccess: async (host: string, user_id: string) =>
    (await initAxios())
      ?.get(`/tenant/lookup/admin/${host}?userId=${user_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getTenantAccessHost: async (host: string, user_id: string) =>
    (await initAxios())
      ?.get(`/tenant/lookup/admin/${host}?userId=${user_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getIDP: async () =>
    (await initAxios(undefined, false))
      ?.get('/idp/host-idp')
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getIDPHost: async (host: string) =>
    (await initAxios(undefined, false))
      ?.get(`/idp/host/${host}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  brokerLogin: async (token: any, domain: string) =>
    (await initAxios(undefined, false))
      ?.post(
        '/partner-sso/broker-login/',
        JSON.stringify({ token: token, tenant_name: domain }),
        { withCredentials: true },
      )
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  refreshBrokerToken: async () =>
    (await initAxios(undefined, false))
      ?.post('/partner-sso/refresh-token/', undefined, {
        withCredentials: true,
      })
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        // Session refresh is control flow, not a display-data request. Preserve
        // the axios status so KeycloakService can tell a rejected refresh token
        // (400/401/403) from an offline blip or server outage.
        throw err;
      }),
  clearBrokerRefreshToken: async () =>
    (await initAxios(undefined, false))
      ?.delete('/partner-sso/refresh-token/', { withCredentials: true })
      .then((resp) => {
        return {
          success: resp.status === 204,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default TenantAPI;
